import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c113ce8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ss-card",
  style: {"height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ss-titulo-card" }, "Meus Widgets", -1))
const _hoisted_3 = {
  key: 0,
  style: {"height":"80%"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-row",
  style: {"width":"100%","height":"100%"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100%","height":"100%"},
    src: "/static/img/ilustracoes/hello-world.svg"
  })
], -1))
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { style: {"width":"100%","text-align":"center"} }
const _hoisted_7 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"height":"100%"}
}
const _hoisted_8 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widgets_usuario_coluna = _resolveComponent("widgets-usuario-coluna")!
  const _component_widget_usuario_novo_modal = _resolveComponent("widget-usuario-novo-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.state.widgets.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode("Você ainda não tem nenhum widget. "),
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirInclusaoWidget && _ctx.abrirInclusaoWidget(...args)))
              }, "Deseja adicionar seu primeiro widget?")
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: _ctx.state.widgets.length,
          class: "ant-row",
          style: {"width":"100%","height":"95%"}
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_widgets_usuario_coluna, {
              widgets: _ctx.state.widgets,
              "onUpdate:widgets": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.widgets) = $event)),
              coluna: 1
            }, null, 8, ["widgets"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_widgets_usuario_coluna, {
              widgets: _ctx.state.widgets,
              "onUpdate:widgets": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.widgets) = $event)),
              coluna: 2
            }, null, 8, ["widgets"])
          ])
        ])),
    _createVNode(_component_widget_usuario_novo_modal, {
      coluna: 1,
      linha: 0,
      subcoluna: 0,
      sublinha: 0,
      visivel: _ctx.state.exibirInclusao,
      "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.exibirInclusao) = $event)),
      onConfirmacao: _ctx.incluirWidget
    }, null, 8, ["visivel", "onConfirmacao"])
  ]))
}